import { motion } from 'framer-motion';
import classes from './Hero.module.scss';
import ImageOverlay from './ImageOverlay';

const Hero: React.FC<{
  image: string;
  imageAlt: string;
  headerText: string;
  headerColor?: 'white' | 'black' | 'yellow';
  text?: string;
  textPos: 'left' | 'right';
  textColor: 'white' | 'black';
  imageOverlay?: string;
}> = props => {
  return (
    <div className={classes.banner}>
      <img src={props.image} alt={props.imageAlt} />
      {props.imageOverlay && (
        <div
          className={classes.overlay}
          style={{ backgroundColor: props.imageOverlay }}
        ></div>
      )}
      <ImageOverlay textColor={props.textColor} textPos={props.textPos}>
        <motion.h3
          className={`mb-3 ${
            props.headerColor ? classes[`h-c-${props.headerColor}`] : ''
          }`}
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: 'easeOut' }}
        >
          {props.headerText}
        </motion.h3>
        {props.text && (
          <motion.div
            className='large-text'
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, ease: 'easeOut' }}
          >
            {props.text}
          </motion.div>
        )}
      </ImageOverlay>
    </div>
  );
};

export default Hero;
